/* Selector por pasos de los productos de Regalos.

   Las 24 variantes son cuatro decisiones cruzadas: cuantas, que linea,
   como va y si lleva hueco para botella. Aqui solo se resuelve cual de
   las 24 corresponde a lo elegido y se escribe en el input name="id"
   que ya usa la ficha; no se toca nada mas del formulario.

   Sin JavaScript el bloque no aparece (nace con la clase is-js puesta
   desde aqui) y la ficha cae a su lista de pastillas de siempre, que
   sigue en el HTML. Fea, pero comprable. */
(function () {
  'use strict';

  var caja = document.querySelector('[data-mz-regopt]');
  if (!caja) return;

  var mapa;
  try {
    mapa = JSON.parse(caja.querySelector('[data-mz-regopt-mapa]').textContent);
  } catch (e) { return; }

  var claves = Object.keys(mapa);
  if (!claves.length) return;

  caja.classList.add('is-js');
  document.documentElement.classList.add('mz-regopt-js');

  var hidden = document.querySelector('[data-mz-variant]')
            || document.querySelector('form[action$="/cart/add"] input[name="id"]');
  var precioEl = document.querySelector('[data-mz-price]');
  var aviso = caja.querySelector('[data-mz-rg-aviso]');

  function partes(k) {
    var p = k.split('|');
    return { n: p[0], linea: p[1], formato: p[2], botella: p[3] };
  }

  /* Las combinaciones posibles se leen del mapa, no de una lista escrita
     a mano: si Liz agrega o quita una variante, esto la sigue solo. */
  function candidatas(filtro) {
    return claves.filter(function (k) {
      var p = partes(k);
      for (var campo in filtro) {
        if (filtro[campo] !== null && filtro[campo] !== undefined && p[campo] !== filtro[campo]) return false;
      }
      return true;
    });
  }

  function masBarata(lista) {
    var mejor = null;
    lista.forEach(function (k) {
      var v = mapa[k];
      // Entre disponibles gana la barata; si no hay ninguna disponible,
      // al menos se enseña algo en vez de dejar el paso en blanco.
      if (!mejor) { mejor = k; return; }
      var m = mapa[mejor];
      if (v.d !== m.d) { if (v.d) mejor = k; return; }
      if (v.p < m.p) mejor = k;
    });
    return mejor;
  }

  /* El estado arranca en la variante que YA viene elegida en el <select>,
     no en la mas barata del mapa.

     El servidor marca esa opcion con selected cuando la direccion trae
     ?variant=, que es como Shopify arma el enlace del nombre del articulo
     dentro del carrito, el que se comparte por WhatsApp y el de los
     catalogos de Meta y de Google Shopping. Sembrando de la mas barata,
     quien volvia del carrito a revisar su Canasta de 12 Premium de $2,865
     la veia medio segundo y despues el guion se la cambiaba por "1
     Manzzani de Tamarindo, $100": creia haber perdido lo que ya habia
     armado, o lo agregaba otra vez.

     Se lee del elemento y no de la URL a proposito: asi queda cubierto de
     una sola vez el ?variant=, el selected que pinta el servidor y
     cualquier otro origen que se le ocurra a Shopify mañana. */
  var sembrada = null;
  if (hidden && hidden.value) {
    sembrada = claves.filter(function (k) { return String(mapa[k].id) === String(hidden.value); })[0] || null;
  }
  var estado = partes(sembrada || masBarata(claves.filter(function (k) { return mapa[k].d; })) || claves[0]);

  function pinta(porUsuario) {
    // --- paso 2: lineas disponibles PARA ESE tamaño ---
    var lineasOk = {};
    candidatas({ n: estado.n }).forEach(function (k) { lineasOk[partes(k).linea] = true; });
    if (!lineasOk[estado.linea]) estado.linea = Object.keys(lineasOk)[0];
    caja.querySelectorAll('[data-mz-rg-linea]').forEach(function (b) {
      var l = b.getAttribute('data-mz-rg-linea');
      b.hidden = !lineasOk[l];
      var on = l === estado.linea;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    // --- paso 3: suelta o en canasta, solo si de verdad hay las dos ---
    var formatosOk = {};
    candidatas({ n: estado.n, linea: estado.linea }).forEach(function (k) { formatosOk[partes(k).formato] = true; });
    var hayEleccion = Object.keys(formatosOk).length > 1;
    var grpF = caja.querySelector('[data-mz-rg-grupo="formato"]');
    if (grpF) grpF.hidden = !hayEleccion;
    if (!formatosOk[estado.formato]) estado.formato = Object.keys(formatosOk)[0];
    caja.querySelectorAll('[data-mz-rg-formato]').forEach(function (b) {
      var f = b.getAttribute('data-mz-rg-formato');
      b.hidden = !formatosOk[f];
      var on = f === estado.formato;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    // --- paso 4: la botella solo donde existe ---
    var conBotella = candidatas({ n: estado.n, linea: estado.linea, formato: estado.formato, botella: '1' });
    var grpB = caja.querySelector('[data-mz-rg-grupo="botella"]');
    if (grpB) grpB.hidden = conBotella.length === 0;
    if (conBotella.length === 0) estado.botella = '0';
    var chk = caja.querySelector('[data-mz-rg-botella]');
    if (chk) chk.checked = estado.botella === '1';

    /* --- paso 1: tamaños, cada uno con su precio mas bajo ---
       Va al final aunque en la pantalla vaya primero, y es a proposito:
       los pasos 2 y 3 corrigen estado.linea y estado.formato cuando el
       tamaño recien elegido no los admite, y este bucle cotiza CONTRA ese
       estado. Cuando cotizaba antes que ellos usaba la linea y el formato
       viejos, los que los pasos 2 y 3 estaban a punto de tirar. Se notaba
       en la pastilla de 1 Manzzani, el unico tamaño que existe en las
       cuatro lineas y en los dos formatos —los demas se salvaban por la
       red de abajo—: yendo de Tamarindo a 6, la de 1 seguia anunciando
       $100, que es un Tamarindo que en 6 ni existe, y al tocarla brincaba
       a $240 bajo el dedo. Cotizando al final ya no queda nada rancio. */
    caja.querySelectorAll('[data-mz-rg-n]').forEach(function (b) {
      var n = b.getAttribute('data-mz-rg-n');

      /* El precio del tamaño se cotiza EN LA LINEA QUE ESTAS VIENDO.

         Antes filtraba solo por tamaño, asi que la pastilla enseñaba la
         combinacion mas barata de todas las lineas y nunca cambiaba al
         cambiar de linea: con Premium elegido decia $100, que es el
         Tamarindo, mientras el precio de arriba decia $235. Peor aun,
         Tamarindo y Tamarindo-con-ingrediente marcaban lo mismo aunque
         valen $100 y $130.

         Se cae con red: si esa linea no existe en ese tamaño se prueba
         sin el formato, y si tampoco, se vuelve al minimo del tamaño,
         que es mejor que dejar la pastilla en blanco. */
      var posibles = candidatas({ n: n, linea: estado.linea, formato: estado.formato });
      if (!posibles.length) posibles = candidatas({ n: n, linea: estado.linea });
      if (!posibles.length) posibles = candidatas({ n: n });
      var barata = masBarata(posibles);
      var p = b.querySelector('[data-mz-rg-precio]');
      if (p && barata) {
        /* Ese numero es el minimo de lo que cabe en el tamaño, no un
           precio cerrado: la de 3 en Clasica vale $645 sin botella y $675
           con ella, y la pastilla enseñaba $645 a secas. Cuando detras hay
           mas de un precio se avisa con un "desde", como ya hace el
           selector de la pagina de Canastas; cuando solo hay uno se dice
           el precio pelon, porque prometer "desde $100" donde no existe
           nada mas caro confunde igual. */
        var varios = posibles.some(function (k) { return mapa[k].p !== mapa[barata].p; });
        p.textContent = (varios ? 'desde ' : '') + mapa[barata].pt;
      }
      var on = n === estado.n;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      var hayStock = posibles.some(function (k) { return mapa[k].d; });
      b.classList.toggle('is-agotada', !hayStock);
    });

    resuelve(porUsuario);
  }

  function resuelve(porUsuario) {
    var k = [estado.n, estado.linea, estado.formato, estado.botella].join('|');
    var v = mapa[k];
    if (!v) {
      // La combinacion no existe: se cae a la mas parecida en vez de
      // dejar el boton apuntando a una variante que no es.
      var alt = masBarata(candidatas({ n: estado.n, linea: estado.linea }));
      if (!alt) alt = masBarata(candidatas({ n: estado.n }));
      if (!alt) return;
      estado = partes(alt);
      v = mapa[alt];
    }
    if (hidden) {
      hidden.value = v.id;
      hidden.dataset.title = v.n || '';
      hidden.dataset.price = v.p || '';
      /* El selector de sabores acota la galeria segun la linea, y aqui
         ya la sabemos: se la pasamos como dato en vez de obligarla a
         adivinarla del nombre de la variante. "tam-extra" es tamarindo
         con ingrediente, que para el cap cuenta como tamarindo. */
      hidden.dataset.nivel = (estado.linea === 'tam-extra') ? 'tamarindo' : estado.linea;

      /* ...pero esa normalizacion borra el unico dato que separa la
         Manzzani de tamarindo sencilla ($125) de la que lleva
         ingrediente extra ($150). Sin el, la galeria ofrecia las seis
         en las dos lineas y se podia pagar la sencilla llevandose una
         con nuez. Se manda aparte para que el armador lo sepa. */
      hidden.dataset.tamExtra = (estado.linea === 'tam-extra') ? '1' : '0';

      /* La URL guarda la variante, igual que en la ficha normal: asi la
         eleccion sobrevive a recargar, al boton de atras y a mandarle el
         enlace a alguien. Solo cuando la movio la persona: si se escribiera
         tambien en el primer pintado, cada visita a la ficha dejaria en la
         barra de direcciones la combinacion mas barata, y quien copiara de
         ahi repartiria una manzana suelta en vez de la canasta que enseño. */
      if (porUsuario && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }

      hidden.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (precioEl) precioEl.textContent = v.pt;
    if (aviso) {
      // El agotado se dice con palabras, no solo poniendo gris el boton.
      aviso.hidden = v.d;
      aviso.textContent = v.d ? '' : 'Esa combinación está agotada. Prueba otro tamaño o línea.';
    }
    var submit = document.querySelector('form[action$="/cart/add"] [type="submit"]');
    if (submit) submit.setAttribute('aria-disabled', v.d ? 'false' : 'true');
  }

  caja.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-mz-rg-n]');
    if (b) { estado.n = b.getAttribute('data-mz-rg-n'); return pinta(true); }
    b = ev.target.closest('[data-mz-rg-linea]');
    if (b) { estado.linea = b.getAttribute('data-mz-rg-linea'); return pinta(true); }
    b = ev.target.closest('[data-mz-rg-formato]');
    if (b) { estado.formato = b.getAttribute('data-mz-rg-formato'); return pinta(true); }
    b = ev.target.closest('[data-mz-rg-directo]');
    if (b) {
      // Variante que no encajo en el analisis: se aplica tal cual.
      var id = b.getAttribute('data-mz-rg-directo');
      if (hidden) { hidden.value = id; hidden.dispatchEvent(new Event('change', { bubbles: true })); }
      caja.querySelectorAll('[data-mz-rg-directo]').forEach(function (o) {
        o.classList.toggle('is-on', o === b);
      });
    }
  });

  caja.addEventListener('change', function (ev) {
    if (!ev.target.matches('[data-mz-rg-botella]')) return;
    estado.botella = ev.target.checked ? '1' : '0';
    pinta(true);
  });

  pinta(false);
})();

/* Selector de la pagina de Canastas.

   Mismo patron que el de Regalos —cuantas, que linea, si lleva hueco
   para botella— pero aqui no se resuelve una variante dentro de un
   formulario: se resuelve a QUE pagina ir, porque cada tamaño es un
   producto distinto. El cuarto paso, los sabores, vive en esa ficha.

   Sin JavaScript el bloque nunca se muestra (los botones nacen con
   hidden y solo este guion los descubre) y queda la cuadricula del
   noscript, que si permite comprar. */
(function () {
  'use strict';

  var caja = document.querySelector('[data-mz-elige]');
  if (!caja) return;

  var mapa;
  try { mapa = JSON.parse(caja.querySelector('[data-mz-elige-mapa]').textContent); }
  catch (e) { return; }

  var claves = Object.keys(mapa);
  if (!claves.length) return;

  var res = caja.querySelector('[data-mz-el-res]');
  var estado = { n: null, linea: null, botella: '0' };

  function partes(k) { var p = k.split('|'); return { n: p[0], linea: p[1], botella: p[2] }; }
  function candidatas(f) {
    return claves.filter(function (k) {
      var p = partes(k);
      return (f.n == null || p.n === f.n) &&
             (f.linea == null || p.linea === f.linea) &&
             (f.botella == null || p.botella === f.botella);
    });
  }
  function masBarata(lista) {
    return lista.reduce(function (mejor, k) {
      return (!mejor || mapa[k].p < mapa[mejor].p) ? k : mejor;
    }, null);
  }

  // Arranca en la mas barata que exista, no en un tamaño escrito a mano:
  // si Liz archiva una canasta, esto sigue apuntando a algo real.
  estado = partes(masBarata(claves));

  function pinta() {
    // --- paso 1: el tamaño, con el precio mas bajo al que se puede
    // llegar por ese camino (sin botella, que siempre suma) ---
    caja.querySelectorAll('[data-mz-el-n]').forEach(function (b) {
      var n = b.getAttribute('data-mz-el-n');
      var posibles = candidatas({ n: n });
      b.hidden = posibles.length === 0;
      if (b.hidden) return;
      var barata = masBarata(posibles);
      var p = b.querySelector('[data-mz-el-precio]');
      if (p && barata) p.textContent = 'desde ' + mapa[barata].pt;
      var on = n === estado.n;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    // --- paso 2: solo las lineas que ese tamaño ofrece ---
    var lineasOk = {};
    candidatas({ n: estado.n }).forEach(function (k) { lineasOk[partes(k).linea] = true; });
    if (!lineasOk[estado.linea]) estado.linea = Object.keys(lineasOk)[0];
    caja.querySelectorAll('[data-mz-el-linea]').forEach(function (b) {
      var l = b.getAttribute('data-mz-el-linea');
      b.hidden = !lineasOk[l];
      var on = l === estado.linea;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    /* --- paso 3: la botella, solo donde existe ---
       Hoy la ofrecen la de tres y la de seis. No va escrito aqui: se
       pregunta al mapa. Si alguien la marca y luego se va a un tamaño
       que no la tiene, la eleccion se cae sola en vez de dejar el
       estado apuntando a una combinacion inexistente. */
    var conBotella = candidatas({ n: estado.n, linea: estado.linea, botella: '1' });
    var grpB = caja.querySelector('[data-mz-el-grupo="botella"]');
    if (grpB) grpB.hidden = conBotella.length === 0;
    if (conBotella.length === 0) estado.botella = '0';
    var chk = caja.querySelector('[data-mz-el-botella]');
    if (chk) chk.checked = estado.botella === '1';

    // --- resultado ---
    var v = mapa[estado.n + '|' + estado.linea + '|' + estado.botella];
    if (!v) { if (res) res.hidden = true; return; }
    if (res) res.hidden = false;

    var img = caja.querySelector('[data-mz-el-img]');
    if (img) {
      img.src = v.img;
      img.alt = v.t;
      /* Ocho de las diez canastas siguen con la foto vieja en JPG y solo
         dos tienen el recorte en PNG. Un recorte flota bien con sombra
         proyectada; una foto rectangular con esa misma sombra parece un
         error. Se distingue por la extension del archivo —un dato, no
         una corazonada— y cada una recibe el trato que le sienta.
         Cuando esten los ocho recortes que faltan, esto se apaga solo. */
      var ruta = v.img.split('?')[0];
      img.classList.toggle('es-foto', !/\.png$/i.test(ruta));
    }

    var set = function (sel, txt) { var el = caja.querySelector(sel); if (el) el.textContent = txt; };
    set('[data-mz-el-nom]', v.t);
    // La composicion la calcula el Liquid; la de botella hereda la de su
    // hermana, asi que marcar la casilla no borra lo que lleva dentro.
    set('[data-mz-el-comp]', v.c || '');
    set('[data-mz-el-precio-grande]', v.pt);
    var cta = caja.querySelector('[data-mz-el-cta]');
    if (cta) cta.setAttribute('href', v.u);
  }

  caja.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-mz-el-n]');
    if (b) { estado.n = b.getAttribute('data-mz-el-n'); return pinta(); }
    b = ev.target.closest('[data-mz-el-linea]');
    if (b) { estado.linea = b.getAttribute('data-mz-el-linea'); return pinta(); }
  });

  caja.addEventListener('change', function (ev) {
    if (!ev.target.matches('[data-mz-el-botella]')) return;
    estado.botella = ev.target.checked ? '1' : '0';
    pinta();
  });

  pinta();
})();
